import endpoints from "../utils/endpoints";
import { Api } from "./api";
import { removeEmpty } from "../utils/objectUtils";
import { notificationError, notificationSucces } from "./notification";

export async function getCashiersList(params: any){
    let res = {
      count: 0,
      page: null,
      perpage: 0,
      list: [],
    };
    if(params) {
      params = removeEmpty(params)
    }
    await Api.get(endpoints.getCashiersList, {params}).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Error on getting cashiers')
    })
    
    return res
}

export async function updateCashierStatus(params: any){

    await Api.get(endpoints.updateCashierStatus, {params}).then((response) => {
      if(response.status === 200) {
          if(response.data.error) {
              notificationError(`${response.data.message}`)
          } else {
              notificationSucces('Status changed successfully')
          }
      } else {
        notificationError('Could not update cashier status')
      }
    }).catch((err: string) => {
      notificationError('Could not get data from servers')
    })
}

export async function createOrUpdateCashier(payload: any) {
  let res = {success: true}
  await Api.post(endpoints.createOrUpdateCashier, payload).then((response) => {
    if(response.status === 200) {
        if(response.data.error) {
            notificationError(`${response.data.message}`)
            res.success = false
        } else {
            notificationSucces('Cashier was successfully saved')
            res.success = true
        }
    } else {
      notificationError('Could not send request to the server')
      res.success = false

    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
    res.success = false
  })
  return res
}

export async function getCashierById(params: any) {
  let res = {
    id: null,
    locationId: "",
    locationName: "",
    login: "",
    password: "",
    name: "",
    status: "Active",
    canAccessPeriodSummary: "yes",
    canViewDrawerReport: "yes",
  }
  await Api.get(endpoints.getCashierById, {params}).then((response) => {
    if(response.status === 200) {
        if(response.data.error) {
            notificationError(`${response.data}`)
        } else {
            res = response.data
        }
    } else {
      notificationError('Could not send request to the server')
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })
  return res
}


export async function getDrawerCashiersList(params: any){
    let res = {
      count: 0,
      page: null,
      perpage: 0,
      list: [],
    };
    if(params) {
      params = removeEmpty(params)
    }
    await Api.get(endpoints.getDrawerCashiersList, {params}).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get data from servers')
    })
    
    return res
}

export async function updateDrawerCashiers(payload: any){

  await Api.post(endpoints.updateDrawerCashiers, payload).then((response) => {
    if(response.status === 200) {
        if(response.data.error) {
            notificationError(`${response.data}`)
        } else {
            notificationSucces('Drawer cashier updated successfully')
        }
    } else {
      notificationError('Could not update Drawer cashier')
    }
  }).catch((err: string) => {
    notificationError('Could not update Drawer cashier')
  })
}



